/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

function scrollToAnchor(aid){
  var aTag = $("a[name='"+ aid +"']");
  $('html,body').animate({scrollTop: aTag.offset().top},'slow');
}
function scrollToId(id, offset){
	var aTag = $("#" + id);
	$('html,body').animate({scrollTop: aTag.offset().top-offset},'slow');
	$("[data-scroll-top]").show();
}

(function() {

  /**** PDP Slide Down CTA *******/
  const pdpStickyBarAdjust = (variant) => {
    const pdpStickyBarVar = document.querySelector("#pdp-sticky-cta #variant-text div");
    if(pdpStickyBarVar) {
      if(variant.options.length > 2) {
        pdpStickyBarVar.textContent = `${variant.options[1]} / ${variant.options[2]}`;
      } else {
        pdpStickyBarVar.textContent = variant.title;
      }
    }
  };
  document.addEventListener('DOMContentLoaded', function() {
    const floatingBar = document.getElementById('pdp-sticky-cta');
    if(!floatingBar) {
      return;
    }
    const scrollTrigger = window.innerWidth < 450 ? 1600 : 750;

    function scrollCheck() {
      if (window.scrollY > scrollTrigger) {
        floatingBar.classList.add('visible');
      } else {
        floatingBar.classList.remove('visible');
      }
    }

    // Show or hide the bar based on scroll position
    window.addEventListener('scroll', function() {
      scrollCheck();
    });

    // Bind click event for the Buy Now button
    document.getElementById('pdp-sticky-cta-btn').addEventListener('click', function(e) {
      const newBuyBtn = document.querySelector(".buy-now-btn");
      e.currentTarget.disabled = true;
      e.currentTarget.innerHTML = "One Moment...";
      e.currentTarget.classList.add("loading");
      newBuyBtn.click();
    });

    scrollCheck();
  });

  /**** PDP Size Guides *****/
  const sizeGuideContentContainer = document.querySelector(".size-popup-content");
  if(sizeGuideContentContainer) {
    const sizeGuideFetch = async () => {

      const sizeGuideRequest = await fetch(sizeGuideContentContainer.getAttribute("data-url"), {
        method: 'GET',
        headers: {
          'Content-Type': 'text/html'
        }
      });
      const sizeGuideResponse = await sizeGuideRequest.text();
      sizeGuideContentContainer.innerHTML = sizeGuideResponse;
    };
    sizeGuideFetch();
  }  

  /*** Discount Loaded DIV */
  const discountLoaded = document.querySelector(".pr-discount-loaded-display");
  if(discountLoaded) {
    const QS = new URLSearchParams(document.location.search);
    const PRD = QS?.get("prd") || "";
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    };

    const discountCode = getCookie("discount_code");
    if (discountCode || PRD.length > 0) {
      discountLoaded.style.display = "block";
    }
  }

  /**** Custom Variant Changing Functionality **** */
  const variantRadios = document.querySelector("variant-radios");
  const stringHandle = (str) => {
    return str.toLowerCase().replace(/ /g,"-").trim();
  };
  const variantImagesAdjust = (variant) => {
    const thisQuiltSizeParts = (variant.options.length > 1) ? variant.options[1].split("-") : variant.options[0].split("-");
    const thisQuiltSize = thisQuiltSizeParts[thisQuiltSizeParts.length-1].replace(/size/gi,'').trim();
    const lifeStyleSearch = (variant.options.length > 1) ? "lifestyle-" + stringHandle(thisQuiltSize) : "";
    const lifeStyleGlobalSearch = (variant.options.length > 2) ? "lifestyle-global" : "";
    const sizeColorSearch = (variant.options.length > 2) ? stringHandle(thisQuiltSize) + "XX-" + stringHandle(variant.options[2]) : "";    
    const quiltProdTemplate = document.querySelector("body").classList.contains("template-product-quilt-product") || document.querySelector("body").classList.contains("template-product-quilt-product-new") || document.querySelector('.product-section');
    let thumbCount = 0;    
    document.querySelectorAll(".thumbnail-list__item").forEach(thumb => {
      const thumbImage = thumb.getAttribute("data-image");
      if(true || !quiltProdTemplate || variant.options.length < 2 || thumbImage.indexOf(lifeStyleSearch) >= 0 || thumbImage.indexOf(lifeStyleGlobalSearch) >= 0 || thumbImage.indexOf(sizeColorSearch) >= 0) {
        thumb.classList.add("active");
        thumbCount++;
      } else {
        thumb.classList.remove("active");
      } 
    });
    if(quiltProdTemplate) {
      document.querySelectorAll(".quilt-media-gallery__wrapper").forEach(thumb => {
        const thumbImage = thumb.getAttribute("data-image");
        if(!quiltProdTemplate || variant.options.length < 2 || thumbImage.indexOf(lifeStyleSearch) >= 0 || thumbImage.indexOf(lifeStyleGlobalSearch) >= 0 || thumbImage.indexOf(sizeColorSearch) >= 0) {
          thumb.classList.add("active");
        } else {
          thumb.classList.remove("active");
        } 
      });
    }
    document.querySelectorAll(".media-gallery__nav-item").forEach(nav => {
      nav.classList.remove("u-hidden");
    });

    /* PDP QUILT IMAGE TESTING */
    const pdpImageTesting = () => {
      if((typeof PDP_IMAGE_TEST_ON !== "undefined") && PDP_IMAGE_TEST_ON === true) {
        const lifestyleGlobalImage = document.querySelectorAll(".quilt-media-gallery__wrapper[data-image*='lifestyle-global']");
        if(lifestyleGlobalImage.length > 0) {

          //DESKTOP: move the lifestyle global image to the first position within its parent
          const parent = lifestyleGlobalImage[0].parentNode;
          const firstChild = parent.firstChild;
          parent.insertBefore(lifestyleGlobalImage[0], firstChild);

          //MOBILE: click on the lifestyle global image
          const mobileLifestyleGlobalImage = document.querySelector(`.thumbnail-list__item[data-image*='lifestyle-global'] button.thumbnail`);
          if(mobileLifestyleGlobalImage) {
            window.setTimeout(() => {
              mobileLifestyleGlobalImage.dispatchEvent(new Event("click"));
            }, 500);
          }
        }
      } else {
        const lifestyleGlobalImage = document.querySelectorAll(".quilt-media-gallery__wrapper[data-image*='lifestyle-global']");
        if(lifestyleGlobalImage.length > 0) {
          lifestyleGlobalImage[0].style.display = "none";
        }
      }
    };
    window.setTimeout(pdpImageTesting, 200);


  };
  if(variantRadios) {
    variantRadios.addEventListener("variants:change", e => {
      const thisVariant = e.detail.variant;      
      variantImagesAdjust(thisVariant);
      pdpStickyBarAdjust(thisVariant);
      variantRadios.setAttribute("data-var-sku", thisVariant.sku);
    });    
    variantImagesAdjust(THIS_VAR);
    pdpStickyBarAdjust(THIS_VAR);
    variantRadios.setAttribute("data-var-sku", THIS_VAR.sku);
  }
  const pdpLadder = (variant) => {
    const ladderMsgElem = document.querySelector(".pr-pdp-ladder-msg");
    if(!ladderMsgElem) {
      return;
    }
    if(!document.querySelector("body").classList.contains("template-product-ladder") && !document.querySelector("body").classList.contains("template-product-gift-card")) {
      return;
    }
    const QS = new URLSearchParams(document.location.search);
    let additional = (QS?.get("prdd") || "").split("p_")[0];
    const PRD = QS?.get("prd") || "";    
    if(additional.length > 0) {
      additional = parseFloat(additional.substring(1));      
      if(!(+additional)) {
        additional = "";
      }
    } else if(PRD === "2501") {
      const thisSize = variant.option2;
      if(thisSize == "Twin") {
        additional = 40;
      } else if(thisSize != "Lap") {
        additional = 50;
      }
    } else if(PRD === "2502") {
      const thisSize = variant.option2;
      if(thisSize == "Twin" || thisSize == "Full") {
        additional = 40;
      } else if(thisSize != "Lap") {
        additional = 50;
      }
    } else if(PRD === "2503") {
      const thisSize = variant.option1;
      if(thisSize == "Lap" || thisSize == "Twin") {
        additional = 50;
      } else {
        additional = 60;
      }
    }
    const currentPriceElem = document.querySelector(".price__text .price__number .money");    
    const ladderMsgAdditional = document.querySelector(".pr-pdp-ladder-msg-additional");
    const ladderMsgAdditionalAmount = document.querySelector(".pr-pdp-ladder-msg-additional span");
    let ladderMsg = "Shop for larger quilts and save more!";
    if(variant.compare_at_price) {
      ladderMsg = `You save $${Math.round((variant.compare_at_price - variant.price)/100)} on this quilt!`;
      //ladderMsgElem.classList.add("pr-pdp-ladder-msg--save");
    } else {
      //ladderMsgElem.classList.remove("pr-pdp-ladder-msg--save");
    }    
    if(ladderMsgAdditional && ladderMsgAdditionalAmount && additional > 0) {
      const discountAmount = Math.trunc(variant.price * (additional / 100)) / 100;
      ladderMsgAdditionalAmount.innerHTML = additional;      
      const newPrice = variant.price - discountAmount*100;
      currentPriceElem.innerHTML = `$${(newPrice/100).toFixed(2)}`;
      currentPriceElem.style.color = "red";
      ladderMsgAdditional.style.display = "flex";
      if(variant.compare_at_price) {
        ladderMsg = `You save $${Math.round((variant.compare_at_price - newPrice)/100)} on this quilt!`;
      }
    } else {
      ladderMsgAdditional.style.display = "none";
    }
    if(ladderMsgElem) {
      ladderMsgElem.innerHTML = ladderMsg;
    }
  };
  if(document.querySelector('variant-radios')) {
    document.querySelector('variant-radios').addEventListener('variants:change', (e) => {
      pdpLadder(e.detail.variant);
    });
  }
  pdpLadder(THIS_VAR);  

  /**** Special Buy Button Functionality **** */
  const newBuyBtn = document.querySelector(".buy-now-btn");
  const variantSelect = document.querySelector(`input[name="id"]`);
  
  if(newBuyBtn && variantSelect) {

    const cartClear = async () => {

      await fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })

    };

    const cartAddItem = async (variantId) => {

      const qtySelector = document.querySelector(`input[name="quantity"]`);
      const discountSelector = document.querySelector(`input[name="prdiscount"]`);
      const propSelector = document.querySelectorAll(`.prcartprops`);

      //add a discount first?
      if(discountSelector && discountSelector?.value?.length > 0) {
        await fetch(window.Shopify.routes.root + 'discount/' + discountSelector.value);
      }

      //special URL parameter that will add a discount based on the variant ID
      const QS = new URLSearchParams(document.location.search);
      const PRD = QS?.get("prd") || "";
      const varLookup = {

        "2501": {
          /* Twin */
          "4341982785": "prd2501t",
          "4341982977": "prd2501t",
          "4341983041": "prd2501t",
          "4341983105": "prd2501t",
          "4341983169": "prd2501t",
          "42391589453960": "prd2501t",
          "4347774465": "prd2501t",

          /* Full */
          "4341983233": "prd2501fup",
          "4341983361": "prd2501fup",
          "4341983425": "prd2501fup",
          "4341983489": "prd2501fup",
          "4341983553": "prd2501fup",
          "42391589486728": "prd2501fup",
          "4348109953": "prd2501fup",

          /* Large Throw */
          "32655435890824": "prd2501fup",
          "32655465250952": "prd2501fup",
          "32655465873544": "prd2501fup",
          "32655467544712": "prd2501fup",
          "32655469805704": "prd2501fup",
          "42391589519496": "prd2501fup",
          "32655470198920": "prd2501fup",

          /* Queen */
          "4341983617": "prd2501fup",
          "4341983745": "prd2501fup",
          "4341983809": "prd2501fup",
          "4341983873": "prd2501fup",
          "4341984001": "prd2501fup",
          "42391589552264": "prd2501fup",
          "4348670593": "prd2501fup",

          /* King */
          "4341984065": "prd2501fup",
          "4341984193": "prd2501fup",
          "4341984257": "prd2501fup",
          "4341984321": "prd2501fup",
          "4341984385": "prd2501fup",
          "42391589585032": "prd2501fup",
          "4344876609": "prd2501fup",
        },
        "2502": {
          /* Twin */
          "4341982785": "prd2502tf",
          "4341982977": "prd2502tf",
          "4341983041": "prd2502tf",
          "4341983105": "prd2502tf",
          "4341983169": "prd2502tf",
          "42391589453960": "prd2502tf",
          "4347774465": "prd2502tf",

          /* Full */
          "4341983233": "prd2502tf",
          "4341983361": "prd2502tf",
          "4341983425": "prd2502tf",
          "4341983489": "prd2502tf",
          "4341983553": "prd2502tf",
          "42391589486728": "prd2502tf",
          "4348109953": "prd2502tf",

          /* Large Throw */
          "32655435890824": "prd2502ltup",
          "32655465250952": "prd2502ltup",
          "32655465873544": "prd2502ltup",
          "32655467544712": "prd2502ltup",
          "32655469805704": "prd2502ltup",
          "42391589519496": "prd2502ltup",
          "32655470198920": "prd2502ltup",

          /* Queen */
          "4341983617": "prd2502ltup",
          "4341983745": "prd2502ltup",
          "4341983809": "prd2502ltup",
          "4341983873": "prd2502ltup",
          "4341984001": "prd2502ltup",
          "42391589552264": "prd2502ltup",
          "4348670593": "prd2502ltup",

          /* King */
          "4341984065": "prd2502ltup",
          "4341984193": "prd2502ltup",
          "4341984257": "prd2502ltup",
          "4341984321": "prd2502ltup",
          "4341984385": "prd2502ltup",
          "42391589585032": "prd2502ltup",
          "4344876609": "prd2502ltup",
        },
        "2503": {
          /* Lap Gift Card */
          "42456494989": "prd2503lt",

          /* Twin Gift Card */
          "1733423529997": "prd2503lt",

          /* Full Gift Card */
          "1733455216653": "prd2503fup",

          /* Large Throw Gift Card */
          "33832321024136": "prd2503fup",

          /* Queen Gift Card */
          "33832369684616": "prd2503fup",

          /* King Gift Card */
          "41852306030728": "prd2503fup"
        }
      };
      if(PRD === "2501" && (PRD in varLookup) && (variantId in varLookup[PRD])) {
        await fetch(window.Shopify.routes.root + 'discount/' + varLookup[PRD][variantId]);
      } else if(PRD === "2502" && (PRD in varLookup) && (variantId in varLookup[PRD])) {
        await fetch(window.Shopify.routes.root + 'discount/' + varLookup[PRD][variantId]);
      } else if(PRD === "2503" && (PRD in varLookup) && (variantId in varLookup[PRD])) {
        await fetch(window.Shopify.routes.root + 'discount/' + varLookup[PRD][variantId]);
      }

      const formData = {items:[]};              

      //personalizations
      const personalizationSelections = document.querySelectorAll(".personalization-selection:checked");
      personalizationSelections.forEach((personalization) => {
        formData.items.push({
          id: personalization.value,
          quantity:1
        });
      });

      //primary item
      const primaryItem = {
        'id': variantId,
        'quantity': parseInt(qtySelector ? qtySelector.value : 1)
      };

      //primary item line item properties
      if(propSelector.length > 0) {
        primaryItem.properties = {};
        propSelector.forEach(prop => {
          primaryItem.properties[prop.getAttribute("name")] = prop.value.trim();
        });
      }

      //apply primary item
      formData.items.push(primaryItem);
      
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(formData)
      });

      document.location = "/checkout";

    };

    newBuyBtn.addEventListener("click", async e => {
      e.preventDefault();
      e.currentTarget.querySelector(".product-form__add-btn__text").innerHTML = e.currentTarget.getAttribute("data-loading-text");
      e.currentTarget.classList.add("loading");
      await cartClear();
      await cartAddItem(variantSelect.value);      
    });
  }
  /* ************************************** */
  
  })();